import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Conversation } from "../components/common/ConversationItem";

interface UseCreateChatProps {
  onError: (error: unknown) => void;
  onSuccess: (conversation: Conversation) => void;
}

interface CreateChatParams {
  text?: string;
}

export const useCreateChat = ({ onSuccess, onError }: UseCreateChatProps) =>
  useMutation<{ conversation: Conversation }, unknown, CreateChatParams>({
    mutationFn: async ({ text }: CreateChatParams) =>
      reactQueryPost(internalApi.helpWidget.createChat(), {
        text,
      }),
    onSuccess: data => {
      onSuccess(data.conversation);
    },
    onError,
  });
